// src/components/header/default/hollo-header-default.ts
import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { holloHeaderStyles } from "./hollo-header-styles";
import { lipsDefaultIconSvg, shutIconSvg, xIcon } from "../../icons";

@customElement("hollo-header-default")
export class HolloHeaderDefault extends LitElement {
  @property({ type: Boolean }) liveCharacter = false;
  @property({ type: String }) currentFlag = ""; // URL of flag image
  @property({ type: Boolean }) showLangMenu = false;
  @property({ type: String }) twinPhoneNumber = "";
  @property({ type: String }) fullName = "";
  @property({ type: String }) profileImageId = "";
  @property({ type: String }) twinPhoneNumberFriendlyForm = "";
  @property({ type: Boolean }) userLoading = false;

  render() {
    return html`
      <div class="hollo-header">
        <div class="hollo-left hollo-user">
          <div class="hollo-user-meta">
            <div class="hollo-user-name">
              ${this.userLoading
                ? html`<span class="hollo-skel-name"></span>`
                : html`<span>${this.fullName || ""}</span>`}
            </div>
            ${this.twinPhoneNumber
              ? html`<a
                  class="hollo-user-phone"
                  href="tel:${this.twinPhoneNumber}"
                >
                  ${this.twinPhoneNumberFriendlyForm}
                </a>`
              : null}
          </div>
        </div>
        <div class="hollo-right hollo-actions">
          <button
            class="hollo-flag-btn flag-btn"
            @click=${() =>
              this.dispatchEvent(new CustomEvent("toggle-language-menu"))}
            aria-haspopup="menu"
            aria-expanded=${String(this.showLangMenu)}
            title="Choose language"
          >
            ${this.currentFlag
              ? html`<img
                  class="hollo-flag-img"
                  src=${this.currentFlag}
                  alt=""
                  width="24"
                  height="24"
                />`
              : html`<span class="flag-emoji">🌐</span>`}
          </button>
          <button
            class="hollo-live-toggle"
            @click=${() => this.dispatchEvent(new CustomEvent("toggle-live"))}
            aria-pressed=${String(this.liveCharacter)}
            title=${this.liveCharacter ? "Turn off live" : "Turn on live"}
          >
            ${this.liveCharacter
              ? shutIconSvg(24, 24)
              : lipsDefaultIconSvg(24, 24)}
          </button>
          <button
            class="hollo-menu-btn"
            @click=${() => this.dispatchEvent(new CustomEvent("toggle-menu"))}
            aria-label="close"
            title="Menu"
          >
            ${xIcon(37)}
          </button>
        </div>
      </div>
    `;
  }

  static styles = holloHeaderStyles;
}

declare global {
  interface HTMLElementTagNameMap {
    "hollo-header-default": HolloHeaderDefault;
  }
}

